import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function NotFoundPage() {
  useDocumentTitle('Not found');
  return (
    <div className="flex flex-col items-center gap-4 py-24 text-center">
      <div className="text-5xl font-bold text-ink-faint">404</div>
      <p className="text-sm text-ink-muted">
        This page wandered off into another container.
      </p>
      <Link to="/" className="btn-secondary">
        Back to overview
      </Link>
    </div>
  );
}
